import React, { forwardRef } from 'react';
import type { MobileStepperProps } from '@mui/material';
import { MobileStepper as MobileStepperMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const MobileStepper = forwardRef<HTMLDivElement, MobileStepperProps>(
  ({ backButton, nextButton, steps, ...props }, ref) => (
    <MobileStepperMUI
      backButton={backButton}
      nextButton={nextButton}
      steps={steps}
      {...omitUndefinedProps(props)}
      ref={ref}
    />
  ),
);

MobileStepper.displayName = 'MobileStepper';

export default MobileStepper;
